import { render, staticRenderFns } from "./fcclock_singlepunchinhubwise.vue?vue&type=template&id=20ef8902"
import script from "./fcclock_singlepunchinhubwise.vue?vue&type=script&lang=js"
export * from "./fcclock_singlepunchinhubwise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports